import { apiRequest } from './client';
import type { IntegrationSummary, WhoopDetailPayload } from './types';

export interface WhoopStatus {
  connected: boolean;
  oauth_configured: boolean;
  connected_at: string | null;
  scope: string | null;
  expires_at: string | null;
}

export async function getWhoopStatus(): Promise<WhoopStatus> {
  return apiRequest<WhoopStatus>('/integrations/whoop/status');
}

export async function disconnectWhoop(): Promise<void> {
  await apiRequest('/integrations/whoop/connection', { method: 'DELETE' });
}

export async function getWhoopDetail(): Promise<IntegrationSummary<WhoopDetailPayload>> {
  return apiRequest<IntegrationSummary<WhoopDetailPayload>>('/integrations/whoop/detail');
}
